import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';
import Select from '../../Select';
import FlagOutlinesSVG from '../../../../svgs/flag-outlines.svg';

const RaceDataBox = ({ race }) => {
    const [loading, setLoading] = useState(true);
    const [raceId, setRaceId] = useState(race);
    const [raceData, setRaceData] = useState([]);

    useEffect(() => {
        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_race_data_box&race_id=${raceId}`)
            .then(res => res.json())
            .then(response => {
                setRaceData(response.data);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    const toggleViewMore = e => {
        e.preventDefault();
        e.target.closest('.toggle').classList.toggle('open');
    };

    const handleRedirectChange = e => {
        const href = `${e.target.options[e.target.selectedIndex].dataset.href}`;

        if (href !== '') {
            window.location.href = href;
        }
    };

    return (
        <div className="database-data proxima toggle">
            <div className="database-data__wrapper">
                {raceData.race_winners && raceData.race_winners.length > 0 && (
                    <>
                        <div className="database-data__head">Race Winner</div>
                            <div className="database-data__content">
                                {raceData.race_winners.map((winner, i) => (
                                    <div key={i} className="database-data__group database-data__icon">
                                        <img src={FlagOutlinesSVG} alt="Flag" />
                                        <a href={winner.driver_url}>
                                            {winner.driver_name}
                                        </a>
                                        {i === 0 && winner.team_name && (
                                            <>
                                                <span>,&nbsp;</span>
                                                <a href={winner.team_url}>
                                                    {winner.team_name}
                                                </a>
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                    </>
                )}
                {raceData.nationality && (
                    <>
                        <div className="database-data__head">Country</div>
                        <div className="database-data__content database-data__icon"
                             dangerouslySetInnerHTML={{ __html: raceData.nationality }}></div>
                    </>
                )}
                {raceData.circuit && (
                    <>
                        <div className="database-data__head">Circuit</div>
                        <div className="database-data__content">
                            <a href={raceData.circuit.url}>
                                {raceData.circuit.name}
                            </a>
                        </div>
                    </>
                )}
                {raceData.round && (
                    <>
                        <div className="database-data__head">Round</div>
                        <div className="database-data__content">{raceData.round}</div>
                    </>
                )}
                {raceData.laps && (
                    <>
                        <div className="database-data__head">Laps</div>
                        <div className="database-data__content">{raceData.laps}</div>
                    </>
                )}
                {raceData.race_poles && raceData.race_poles.length > 0 && (
                    <>
                        <div className="database-data__head">Pole</div>
                            <div className="database-data__content">
                                {raceData.race_poles.map((pole, i) => (
                                    <div key={i} className="database-data__group">
                                        <a href={pole.driver_url}>
                                            {pole.driver_name}
                                        </a>
                                        {i === 0 && pole.team_name && (
                                            <>
                                                <span>,&nbsp;</span>
                                                <a href={pole.team_url}>
                                                    {pole.team_name}
                                                </a>
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                    </>
                )}
                {raceData.fastest_lap && (
                    <>
                        <div className="database-data__head">Fastest Lap</div>
                        <div className="database-data__content">
                            <>
                                <span>{raceData.fastest_lap.name}</span>
                                {raceData.fastest_lap.time && (
                                    <span className="database-data__content--lower">
                                        <>
                                            <span>,&nbsp;</span>
                                            {raceData.fastest_lap.time}
                                        </>
                                    </span>
                                )}
                            </>
                        </div>
                    </>
                )}
                {raceData.total_distance && (
                    <>
                        <div className="database-data__head">Total Distance</div>
                        <div className="database-data__content">{raceData.total_distance} miles</div>
                    </>
                )}
                {raceData.races && raceData.races.length > 0 && (
                    <>
                        <div className="database-data__head">
                            {raceData.cross_site ? 'Season' : `${raceData.season} Season`}
                        </div>
                        {raceData.cross_site ? (
                            <div className="database-data__content">{seasonRace.name}</div>
                        ) : (
                            <div className="database-data__content database-data__select easyselect easyselect--transparent">
                                <Select
                                    name="race-season-races"
                                    id="race-season-races"
                                    default={raceData.race}
                                    onChange={handleRedirectChange}
                                    options={raceData.races.map((seasonRace, i) => (
                                        <option key={i} data-href={seasonRace.url}>
                                            {seasonRace.name}
                                        </option>
                                    ))}
                                />
                            </div>
                        )}
                    </>
                )}
                {raceData.past_races && raceData.past_races.length > 0 && (
                    <>
                        <div className="database-data__head">Other Results</div>
                        <div className="database-data__content database-data__select easyselect easyselect--transparent">
                            <Select
                                name="race-season-races"
                                id="race-season-races"
                                default={raceData.season}
                                onChange={handleRedirectChange}
                                options={raceData.past_races.map((seasonRace, i) => (
                                    <option key={i} data-href={seasonRace.url}>
                                        {seasonRace.name}
                                    </option>
                                ))}
                            />
                        </div>
                    </>
                )}
                <div className="database-data__expand">
                    <a href="#" className="database-data__more" onClick={toggleViewMore}>View More</a>
                    <a href="#" className="database-data__less" onClick={toggleViewMore}>View Less</a>
                </div>
            </div>
        </div>
    );
};

export default RaceDataBox;
